var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1588.96 610.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4190f9;}.cls-2{fill:#fcfcfc;}.cls-3{font-size:66.28px;fill:#fff;font-family:Poppins-ExtraLight, Poppins;font-weight:200;letter-spacing:-0.05em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo ai web light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1061.29,
    cy: 305.12,
    r: 305.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.15,1131.16v63H339.76q-38.64,0-60.41-19.13t-21.76-63.41v-66.41h-27V983.7h27v-51h73.92v51H369.4v61.54H331.51v67.91q0,9.76,4.31,13.88t14.45,4.13Z",
    transform: "translate(-230.58 -760.21)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M490.59,993.08a76.1,76.1,0,0,1,39.77-11.25v78.79H509q-24.76,0-37.15,9.57t-12.38,33.2v90.8H385.53V983.7h73.92v39.4A96.34,96.34,0,0,1,490.59,993.08Z",
    transform: "translate(-230.58 -760.21)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M652.86,990.64a58.94,58.94,0,0,1,24.2,26.46V983.7H750.6v210.49H677.06V1160.8a59,59,0,0,1-24.2,26.45q-16.32,9.57-38.46,9.57a82.55,82.55,0,0,1-45.4-13q-20.25-12.94-31.89-37.52t-11.63-57.59q0-33,11.63-57.41T569,994a82.54,82.54,0,0,1,45.4-12.94Q636.54,981.08,652.86,990.64Zm-42,66.42q-10.7,11.45-10.69,31.7,0,20.64,10.69,32.08t27.95,11.44q16.5,0,27.39-11.63t10.88-31.89q0-19.89-10.88-31.52t-27.39-11.63Q621.53,1045.61,610.84,1057.06Z",
    transform: "translate(-230.58 -760.21)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M874.79,1123.28,914.56,983.7H993l-72.42,210.49H829L756.22,983.7H835Z",
    transform: "translate(-230.58 -760.21)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1199.33,1102.27h-139.2q1.88,35.64,31.15,35.64,10.88,0,18-5.25a26.34,26.34,0,0,0,9.75-13.88h78a89.2,89.2,0,0,1-18.38,40,98.77,98.77,0,0,1-36,28,111.56,111.56,0,0,1-47.65,10.13q-31.52,0-55.72-13a91.61,91.61,0,0,1-37.71-37.52q-13.5-24.57-13.5-57.59t13.5-57.41A91.67,91.67,0,0,1,1039.5,994q24.38-12.94,55.53-12.94,31.52,0,55.53,12.75a91.08,91.08,0,0,1,37.33,36.4q13.32,23.64,13.32,54.78A88.58,88.58,0,0,1,1199.33,1102.27Zm-81.79-55.16q-9-8.25-22.51-8.25-14.64,0-23.83,8.25t-10.69,24.39h65.66Q1126.55,1055.38,1117.54,1047.11Z",
    transform: "translate(-230.58 -760.21)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1286.38,916.54v277.65h-73.92V916.54Z",
    transform: "translate(-230.58 -760.21)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1078.31,
    y: 223.49,
    width: 73.92,
    height: 210.49
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1551.65,1001.34q24.76,20.25,31.14,53.65h-69q-2.62-11.25-10.69-16.88t-19.7-5.63q-8.27,0-12.57,3.56t-4.31,10q0,7.88,9.19,11.82t30.2,8.81q24.39,5.27,40.34,11.26a68.68,68.68,0,0,1,27.76,19.51q11.82,13.5,11.82,36.39a55,55,0,0,1-10.13,32.65q-10.12,14.27-29.45,22.32t-45.59,8.07q-44.28,0-70.54-19.14t-31.89-54.78h70.91q1.5,11.64,9.94,17.26t21.2,5.63c5.76,0,10.13-1.25,13.14-3.75a12.1,12.1,0,0,0,4.5-9.76q0-9-9.57-13.13t-30.58-8.25q-24-4.87-39.4-10.7a67.1,67.1,0,0,1-26.82-18.76q-11.44-12.95-11.45-35.83,0-28.5,22.14-46.52t63-18Q1526.88,981.08,1551.65,1001.34Z",
    transform: "translate(-230.58 -760.21)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1731,1194.19l-57.41-87v87h-73.91V916.54h73.91v149l57.78-81.8h85.92l-81.79,105.43,84,105.06Z",
    transform: "translate(-230.58 -760.21)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(34.59 492.94) scale(1.07 1)"
  }, "TRAVEL KARO, ISHQ KARO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.481a05216f5315e44b49f2ff555dbe9c.svg";
export { ForwardRef as ReactComponent };